// constants
// TODO - on widgets refactor remove below code
export { WIDGET_TYPES } from 'shared/layouts/DetailsPage/constants';

import { BASE_GUTTER_SPACE } from 'shared/styles/base';

export const CAV_DWEB_CONSTANTS = {
  imageGutter: BASE_GUTTER_SPACE * 1.5,
  margin: BASE_GUTTER_SPACE * 3,
  width: 267,
  minimumWidgetCount: 3,
};

// assuming all widgets are rendered
export const DEFAULT_BANNER_WIDGET_INDEX = 7;
